module.exports = __webpack_public_path__ + "static/media/wemby-banner-min.f51775e8.png";